import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './testing/battleRoomTestBootstrap';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { preflightAuthRedirect } from './utils/authRedirect';

// date_of_change: 2026-09-14
// security_reference: Sanitize auth return input before React renders so Clerk never initializes against an unsafe query.
const authRedirectPreflight = preflightAuthRedirect(window);
if (!authRedirectPreflight.safeToRender) {
  throw new Error('Authentication redirect validation failed before application startup.');
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
